// extracted by mini-css-extract-plugin
module.exports = {"items":"OrderItemsList_items__2DFIq","item":"OrderItemsList_item__2Prmu","item__amount":"OrderItemsList_item__amount__Gbd7k","recentOrder":"OrderItemsList_recentOrder__pzIiM"};